import { render, staticRenderFns } from "./ShapeGallerySelector.vue?vue&type=template&id=d355d482&scoped=true&"
import script from "./ShapeGallerySelector.vue?vue&type=script&lang=js&"
export * from "./ShapeGallerySelector.vue?vue&type=script&lang=js&"
import style0 from "./ShapeGallerySelector.vue?vue&type=style&index=0&id=d355d482&prod&lang=scss&scoped=true&"
import style1 from "./ShapeGallerySelector.vue?vue&type=style&index=1&id=d355d482&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d355d482",
  null
  
)

export default component.exports